import type {ModuleSpecBlock,ModuleSpecDocument} from '../data/moduleSpecContracts';
/** Fichier de la porte (`Geode-web-v3/app/uptk/modules/<module>/components/X.tsx`) → chemin du témoin (`components/X.tsx`). */
const COMPONENT_FILE=/(?:^|\/)(components\/[A-Z][A-Za-z0-9]*\.tsx)$/;
export function componentPathOf(file:string|null|undefined):string|null{
 const match=COMPONENT_FILE.exec(file??'');return match?match[1]:null;
}
/** GAP-76 : retrouve, dans la version livrée, le bloc `code` qui référence le témoin ; borné comme le générateur (60 blocs par écran). */
export function findCodeBlock(spec:ModuleSpecDocument|null|undefined,path:string):NonNullable<ModuleSpecBlock['code']>|null{
 const pages=((spec as {pages?:{screen?:{blocks?:ModuleSpecBlock[]}}[]}|null|undefined)?.pages)??[];
 for(const page of pages){
  const queue=[...(page.screen?.blocks??[])];let seen=0;
  while(queue.length&&seen++<60){const block=queue.shift()!;
   if(block.type==='code'&&block.code?.path===path&&block.code.artifactRef)return block.code;
   queue.push(...(block.children??[]));}
 }
 return null;
}
